import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';

import { SendFeedbackProblemEnum } from 'APP/constants/feedback';

import {
  FeedbackIssueType,
  FeedbackIssueTypeProblems,
  MapFeedbackProblemToTranslation,
} from '../../DetailedFeedback.constants';
import { FeedbackIssueButton } from '../FeedbackIssueButton/FeedbackIssueButton';

interface IFeedbackProblemButtonsProps {
  activeProblemType?: SendFeedbackProblemEnum;
  activeIssueType: FeedbackIssueType;
  onButtonClick(val: SendFeedbackProblemEnum): void;
}

export const FeedbackProblemButtons: FC<IFeedbackProblemButtonsProps> = (props) => {
  const { t } = useTranslation();

  const { activeProblemType, onButtonClick, activeIssueType } = props;

  const problemsArray = FeedbackIssueTypeProblems[activeIssueType];

  return (
    <>
      {problemsArray.map((type) => (
        <FeedbackIssueButton
          key={type}
          issueType={type}
          isActive={activeProblemType === type}
          text={t(MapFeedbackProblemToTranslation[type])}
          onClick={onButtonClick}
        />
      ))}
    </>
  );
};
